import { useState } from 'react';
import { useAuth } from './useAuth';
import { hacerSolicitud } from '../helpers/apiClient';
import { useAlert } from '../context/AlertContext';

const useCrearReservacion = (ruta) => {
  const { renovarToken, cerrarSesion } = useAuth();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { mostrarAlerta } = useAlert();

  // ✅ Función para crear reservación
  const crearReservacion = async (formData) => {
    setLoading(true);
    setError(null);

    try {
      const data = await hacerSolicitud(
        ruta,
        {
          method: 'POST',
          body: JSON.stringify({
            ...formData,
            extras: formData.extras || {},
          }),
        },
        renovarToken,
        cerrarSesion,
        false
      );
      mostrarAlerta(`Reservación creada con éxito. Folio: ${data.folio}`, 'success');
      return data;
    } catch (err) {
      setError(err.message);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { crearReservacion, loading, error };
};

export default useCrearReservacion;
